module.exports = __webpack_public_path__ + "img/logo_alchera.47f7b3dc.png";